import React from "react";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import CargoOwnersDropdown from "./dropdowns/CargoOwnersDropdown";
import CarriersDropdown from "./dropdowns/CarriersDropdown";
import DocsDropdown from "./dropdowns/DocsDropdown";
import AnalyticsDropdown from "./dropdowns/AnalyticsDropdown/AnalyticsDropdown";

import MainMenuButton from "./components/MainMenuButton";

import { useStore } from "../../connect";

import { sendNavigationMetric } from "../../utils/sendMetric";

import {
  MAIN_PAGE_QUERY_PARAM_STRING,
  MAIN_PAGE_QUERY_PARAM,
} from "../../consts";

import strings from "../../locales/strings";

import styles from "./MainMenu.scss";

const cx = classnames.bind(styles);

const MainMenu = () => {
  const { baseUrl, search, profile, header, abTest } = useStore();
  const isPrerender = process.env.PRERENDER === "1";
  const currentBaseUrl = isPrerender ? "SSI_PATH_TO_BASE_URL" : baseUrl;

  const isIdPage =
    location && location.href ? /id\./i.test(location.href) : false;

  const isAnonimOnIdPage = !profile.isLoggedIn && isIdPage;

  const openLoginPopup = () => {
    profile.onLoginOpen({
      next: window.location.href,
      additionalQueryParams: header.isMainPage ? MAIN_PAGE_QUERY_PARAM : "",
    });
  };

  const analyticsLabel = strings.mainMenu_analitics[abTest.analyticsHeaderVariant];

  return (
    <div className={cx("main-menu")}>
      {!search.searchVisible && (
        <>
          <MainMenuButton
            className={cx({ "hide-on-mobile": !profile.isLoggedIn })}
            label={strings.loadsSearch}
            smallLabel={strings.mainMenu_loads}
            href={`https://loads.${currentBaseUrl}?utm_source=header&utm_campaign=new_header${
              header.isMainPage ? `&${MAIN_PAGE_QUERY_PARAM_STRING}` : ""
            }`}
            onClick={() =>
              sendNavigationMetric("MAIN_MENU_BUTTON_LOADS_SEARCH")
            }
          />
          <MainMenuButton
            className={cx({ "hide-on-mobile": !profile.isLoggedIn })}
            label={strings.trucksSearch}
            smallLabel={strings.mainMenu_trucks}
            href={`https://trucks.${currentBaseUrl}?utm_source=header&utm_campaign=new_header${
              header.isMainPage ? `&${MAIN_PAGE_QUERY_PARAM_STRING}` : ""
            }`}
            onClick={() =>
              sendNavigationMetric("MAIN_MENU_BUTTON_TRUCKS_SEARCH")
            }
          />
          <MainMenuButton
            dropdownId="cargo-owners"
            className={cx("hide-on-mobile")}
            label={strings.cargoOwners}
            dropdownComponent={
              !isAnonimOnIdPage && <CargoOwnersDropdown isMobile={false} />
            }
            counter={profile.counters.cargoOwners}
            href={
              isAnonimOnIdPage
                ? `https://id.${currentBaseUrl}?utm_source=header&utm_campaign=new_header`
                : undefined
            }
            onClick={
              isAnonimOnIdPage
                ? () => sendNavigationMetric("MAIN_MENU_BUTTON_CARGO_OWNERS")
                : openLoginPopup
            }
          />
          <MainMenuButton
            dropdownId="carriers"
            className={cx("hide-on-mobile")}
            label={strings.carriers}
            counter={profile.counters.carriers}
            dropdownComponent={
              !isAnonimOnIdPage && <CarriersDropdown isMobile={false} />
            }
            href={
              isAnonimOnIdPage
                ? `https://id.${currentBaseUrl}?utm_source=header&utm_campaign=new_header`
                : undefined
            }
            onClick={
              isAnonimOnIdPage
                ? () => sendNavigationMetric("MAIN_MENU_BUTTON_CARRIERS")
                : openLoginPopup
            }
          />
          <MainMenuButton
            dropdownId="ati-docs"
            className={cx("hide-on-mobile")}
            label={strings.mainMenu_atiDocs}
            smallLabel={strings.mainMenu_atiDocs_short}
            counter={profile.counters.docs}
            dropdownComponent={
              !isAnonimOnIdPage && <DocsDropdown isMobile={false} />
            }
            isFullOnDesktop
            href={
              isAnonimOnIdPage
                ? `https://d.${currentBaseUrl}?utm_source=header&utm_campaign=new_header`
                : undefined
            }
            onClick={
              isAnonimOnIdPage
                ? () => sendNavigationMetric("MAIN_MENU_BUTTON_DOCS")
                : openLoginPopup
            }
          />
          {
            analyticsLabel &&
            <MainMenuButton
              dropdownId="ati-analytics"
              className={cx("analytics-menu-button")}
              label={analyticsLabel}
              dropdownComponent={
                !isAnonimOnIdPage && <AnalyticsDropdown isMobile={false} />
              }
              dropdownTriggerOnClick={() => {
                const isDropdownOpen = header.openedDropdown === "ati-analytics";

                if (!isDropdownOpen) sendNavigationMetric(`MAIN_MENU_BUTTON_${abTest.analyticsHeaderVariant.toUpperCase()}`)
                }
              }
              href={
                isAnonimOnIdPage
                  ? `https://id.${currentBaseUrl}?utm_source=header&utm_campaign=new_header`
                  : undefined
              }
              onClick={
              isAnonimOnIdPage
                ? () => sendNavigationMetric(`MAIN_MENU_BUTTON_${abTest.analyticsHeaderVariant.toUpperCase()}`)
                : openLoginPopup
              }
            />
          }
        </>
      )}
    </div>
  );
};

export default observer(MainMenu);
